import React from 'react';
import Translation from '../components/UI/Translation';

//typ funkcji
export type BuildSemester = (rokAkademicki: number, semestrAkademicki: string) => string;
export type BuildReadableSemester = (rokAkademicki: number, semestrAkademicki: string) => JSX.Element;
export type EscapeRegExp = (input: string) => string;
/**
 * Klasa dostarczająca funckjonalność konkatenowania potrzebnych ciagów znaków
 *
 */
class StringBulder {
  /** budowa parametry semestrAkademicki w formie RRRR-S */
  public buildSemester: BuildSemester = (rokAkademicki, semestrAkademicki) => rokAkademicki + '-' + semestrAkademicki;
  /** zastępowanie niepoprawnych znaków wpisanych przez użytkownika w inputach */
  public escapeRegExp: EscapeRegExp = input => input.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  public buildReadableSemester: BuildReadableSemester = (rokAkademicki, semestrAkademicki) => (
    <>
      <Translation id={`SEMESTRAKADEMICKI_${semestrAkademicki === 'Z' ? 'ZIMA' : 'LATO'}`} />
      &nbsp;
      {rokAkademicki}/
      {Number(rokAkademicki + 1)
        .toString()
        .substr(2, 3)}
    </>
  );
  public toUnderscoreUpperCase: EscapeRegExp = text =>
    text
      .replace(/([A-Z]+)/g, ',$1')
      .replace(/^,/, '')
      .split(',')
      .join('_')
      .toUpperCase();
  public dashToUnderscoreUpperCase: EscapeRegExp = text => text.split('-').join('_').toUpperCase();
}

export default new StringBulder();
